import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Faqs from './components/Faqs';
import Tags from './components/Tags';
import translations from './translations.en.json';
import '@fiverr/globals';
import './index.scss';

class SeoSubCategory extends PureComponent {

    constructor(props) {
        super(props);
        i18n.add(translations);
    }

    render() {

        const {
            title,
            faqs,
            tags
        } = this.props;

        if (_.isEmpty(faqs) && _.isEmpty(tags)) {
            return null;
        }

        return (

            <div>
                {!_.isEmpty(faqs) && <Faqs title={title} faqs={faqs}/>}
                {!_.isEmpty(tags) && <Tags title={title} tags={tags}/>}
            </div>
        );
    }
}

SeoSubCategory.propTypes = {
    title: PropTypes.string,
    faqs: PropTypes.array,
    tags: PropTypes.array
};

SeoSubCategory.defaultProps = {
    title: '',
    faqs: [],
    tags: []
};

export default SeoSubCategory;



// WEBPACK FOOTER //
// ./src/SeoSubCategory.js